module.exports = __webpack_public_path__ + "static/media/contactsOrange.47d5e71f.svg";